/**
 * Tenant-scoped chat room document ids.
 *
 * Architecture (tenant isolation rule #1):
 * - Messages are scoped by `tenantId` + `unit` (messageUnit, e.g. "general").
 * - System rooms live at chatRooms/{tenantId}__{roomId} (seeded per tenant).
 * - Custom rooms use their own chatRooms/{roomId} with tenantId on the doc.
 * - Never use flat units/{semanticId} (e.g. units/general) for cross-tenant ids —
 *   those collide in the global units collection and break Firestore reads.
 *
 * Keep in sync with apps/mobile/lib/platform/chat/chat_room_ids.dart and
 * scripts/seed/seed-chat-rooms.js (buildDocId).
 */

/** messageUnit values for seeded system chat rooms (not Firestore unit doc ids). */
export const SYSTEM_CHAT_MESSAGE_UNITS = ['general', 'conference'];

/** chatRooms document id for a tenant system room (e.g. triglav__general). */
export function buildSystemChatRoomDocId(tenantId, roomId) {
  if (!tenantId || !roomId) {
    return '';
  }
  return `${tenantId}__${roomId}`;
}

/** True when unitId is a semantic message channel, not an org units/{id} document. */
export function isSystemChatMessageUnit(unitId) {
  return SYSTEM_CHAT_MESSAGE_UNITS.includes(unitId);
}
